import React from "react";

import { Quote, Star, UserRound } from "lucide-react";

import "./Danhgia.css";

const Danhgia = () => {
  const reviews = [
    {
      name: "Anh Minh",
      location: "Hà Nội",

      content:
        "Tôi cần rút gấp và được hỗ trợ rất nhanh. Chỉ vài phút là nhận được tiền, phí hợp lý. Rất chuyên nghiệp!",
    },

    {
      name: "Chị Hương",
      location: "TP. Hồ Chí Minh",

      content:
        "Dịch vụ uy tín, nhân viên rất nhiệt tình. Hỗ trợ tận nơi, thủ tục đơn giản. Sẽ tiếp tục ủng hộ!",
    },

    {
      name: "Anh Tuấn",
      location: "Đà Nẵng",

      content:
        "Phí thấp hơn nhiều nơi khác, nhận tiền nhanh, an toàn. Rất hài lòng!",
    },
  ];

  return (
    <section className="testimonials-section">
      <div className="testimonials-container">
        {/* SECTION HEADER */}

        <div className="testimonials-heading">
          <h2>KHÁCH HÀNG NÓI GÌ VỀ CHÚNG TÔI?</h2>

          <p>Hàng nghìn khách hàng đã tin tưởng và hài lòng</p>
        </div>

        {/* REVIEWS GRID */}

        <div className="testimonials-grid">
          {reviews.map((review, index) => (
            <div className="testimonial-card" key={index}>
              {/* QUOTE ICON */}

              <Quote
                className="testimonial-quote"
                size={24}
                fill="currentColor"
              />

              {/* REVIEW CONTENT */}

              <p className="testimonial-content">{review.content}</p>

              {/* STAR RATING */}

              <div className="testimonial-stars">
                {[...Array(5)].map((_, starIndex) => (
                  <Star
                    key={starIndex}
                    size={17}
                    fill="currentColor"
                    strokeWidth={1}
                  />
                ))}
              </div>

              {/* CUSTOMER INFO */}

              <div className="testimonial-customer">
                <div className="testimonial-avatar">
                  <UserRound size={27} fill="currentColor" />
                </div>

                <div className="testimonial-customer-info">
                  <strong>{review.name}</strong>

                  <span>{review.location}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Danhgia;
